import { render, staticRenderFns } from "./BranchAdd.vue?vue&type=template&id=e97b1c2a&scoped=true&"
import script from "./BranchAdd.vue?vue&type=script&lang=js&"
export * from "./BranchAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97b1c2a",
  null
  
)

export default component.exports